import React from 'react';
import type { FC } from 'react';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { BackgroundV2 as Background } from '@alfa-bank/site-background-v2';
import { selectAppData } from '@alfa-bank/site-dc-form-api/store';

import type { TLayout } from './models';

export const Layout: FC<TLayout> = ({ children, className, layoutConfig, styles }) => {
    const { step } = useSelector(selectAppData);
    const deviceStyler =
        step === 'firstStep' && layoutConfig.firstStep
            ? layoutConfig.firstStep
            : layoutConfig.allSteps;

    return (
        <Background
            className={cn(styles.layout, styles.external, styles.layoutIndents, className)}
            color="#F2F3F5"
            styler={{ borderRadius: 32, ...deviceStyler }}
        >
            {children}
        </Background>
    );
};
